import { ComponentProps } from "react";

import { Card } from "@mui/material";

import { DefaultError } from "@tanstack/react-query";

import { FaIcon } from "@features/ui";
import { cn } from "@utils/tailwind";

export const ResourceError = ({
  error,
  className,
  ...props
}: { error: DefaultError | Error } & ComponentProps<typeof Card>) => {
  return (
    <Card
      {...props}
      className={cn(
        "flex gap-3 items-start bg-red-50 border-red-100 p-6 max-w-md",
        className
      )}
    >
      <FaIcon
        icon="triangle-exclamation"
        variant="solid"
        className="text-red-600 mt-1"
      />
      <div>
        <h3 className="text-lg text-red-600">Error fetching resource:</h3>
        <p className="text-red-800">{error.message}</p>
      </div>
    </Card>
  );
};
